import { contentId, isPublishing, isSaved, isPublished } from '../state'
import { contentActions } from '../../../actions/content/content'

/**
 * Publish content
 * @param {string} assetId - Asset ID
 * @param {Array} platforms - Platforms to publish to
 * @returns {Promise<boolean>} Success status
 */
export const publishContent = async (assetId, platforms) => {
  if (!contentId.value || !isSaved.value) return false
  
  isPublishing.value = true
  
  try {
    const result = await contentActions.publishContent(contentId.value, assetId, platforms)
    
    if (result) {
      isPublished.value = true
      return true
    }
    
    return false
  } catch (error) {
    console.error('Error publishing content:', error)
    return false
  } finally {
    isPublishing.value = false
  }
}
